<div class="wrapper">
    <div class="header dave-background-image">
        <h2 mat-dialog-title>Neuen Partner anlegen</h2>
    </div>
    <ngx-simplebar class="scrollbar">
        <div class="body">
            <div class="content card-wrapper">
                <mat-card class="card">
                    <form [formGroup]="PartnerForm" name="Partner" (ngSubmit)="Submit$.next()">
                        <div class="input">
                            <div class="container">
                                <app-textfield Key="Name" [Required]="true" [Value]="PartnerForm.controls.Name" class="full"></app-textfield>
                                <mat-slide-toggle
                                    (toggleChange)="this.PartnerForm.get('IsObligoPartner').setValue(!this.PartnerForm.get('IsObligoPartner').value)"
                                    [checked]="this.PartnerForm.get('IsObligoPartner').value"
                                >
                                    Obligo Partner
                                </mat-slide-toggle>
                                <app-textfield Key="Mitgliedernummer" [Value]="PartnerForm.controls.PartnerNo" [Required]="true" class="full"></app-textfield>
                                <mat-slide-toggle
                                    (toggleChange)="this.PartnerForm.get('AutomaticPartnerNo').setValue(!this.PartnerForm.get('AutomaticPartnerNo').value)"
                                    [checked]="this.PartnerForm.get('AutomaticPartnerNo').value"
                                >
                                    Mitgliedernummer automatisch vergeben
                                </mat-slide-toggle>
                                <fa-icon
                                    icon="question-circle"
                                    matTooltip="Erzeugt eine Mitgliedernummer aus Jahr, Monat und einer fortlaufenden Nummer nach dem Muster P202001-1."
                                    style="margin: 1rem"
                                >
                                </fa-icon>
                                <app-textfield Key="E-Mail" [Value]="PartnerForm.controls.Email" [Required]="true" class="full"></app-textfield>
                                <app-textfield Key="Telefon" [Value]="PartnerForm.controls.PhoneNumber" [Required]="true" class="full"></app-textfield>
                                <app-textfield Key="Straße" [Value]="PartnerForm.controls.Street" [Required]="true" class="full"></app-textfield>
                                <app-textfield Key="PLZ" [Value]="PartnerForm.controls.PostalCode" [Required]="true" class="half"></app-textfield>
                                <app-textfield Key="Stadt" [Value]="PartnerForm.controls.City" [Required]="true" class="half"></app-textfield>
                                <app-textfield Key="Land" [Value]="PartnerForm.controls.Country" class="full"></app-textfield>
                                <app-textfield Key="IBAN" [Value]="PartnerForm.controls.Iban" class="full"></app-textfield>
                                <app-textfield Key="BIC" [Value]="PartnerForm.controls.Bic" class="full"></app-textfield>
                                <app-textfield Key="Umsatzsteueridentifikationsnummer" [Value]="PartnerForm.controls.UstId" class="full"></app-textfield>
                                <app-textfield Key="Steuernummer" [Value]="PartnerForm.controls.Steuernummer" class="full"></app-textfield>
                            </div>
                            <div class="buttons">
                                <div class="cancel-button-wrapper">
                                    <button Inverted app-button class="button" type="button" (click)="Cancel()">Abbrechen</button>
                                </div>
                                <button app-button class="button" [Disabled]="PartnerForm.invalid">Speichern</button>
                            </div>
                        </div>
                    </form>
                </mat-card>
            </div>
        </div>
    </ngx-simplebar>
    <div class="dave-background-image"></div>
</div>
